import React from 'react';
import ContainerTemplate from '../../../components/template/Container';
import * as ROUTES from '../../../router/Routes';
import NotificacionesView from './NotificacionesView';

const NotificacionesEntidadPage = () => {
  return (
    <ContainerTemplate active={ROUTES.notificacionesEntidad} routes={[]}>
      <NotificacionesView isForEntity={true} />
    </ContainerTemplate>
  );
};

export default NotificacionesEntidadPage;
